module.exports = __webpack_public_path__ + "static/media/ic_insert_drive_file_selected_36px.361db1fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic_insert_drive_file_selected_36px.svg
// module id = 794
// module chunks = 0